import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './api/baseQuery';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    'Me',
    'Permissions',
    'ActiveTenant',
    'PlatformTenants',
    'EntityType',
    'Entity',
    'Context',
    'Tag',
    'DocumentType',
    'Document',
    'AssociationType',
    'Association',
    'RequirementProfile',
    'ApprovalChain',
    'Approval',
    'Compliance',
    'Notification',
    'NotificationRule',
    'Role',
    'RoleAssignment',
    'TenantUser',
    'WhatsappChannel',
    'AuditLog',
    'EntityOperation',
    'EntityAttribute',
    'EntityAttributeLabel',
    'PortalScope',
    'Tenant',
  ],
  endpoints: () => ({}),
});

export { baseQueryWithReauth, rawBaseQuery, mutex } from './api/baseQuery';
